import {PageBreakRules} from "./page-break-rules.abstract";

export class DefaultRulesService extends PageBreakRules {
  title = "Welcome to Texas Capital Bank";
  subTitle = "Before you start, here's what you need:";
  requiredInfoContainerClass = "tcb-required-info";
  ssImage = "/assets/images/tcb/social-security.svg";
  idTitle = "U.S. Government Issued ID";
  idImage = "/assets/images/tcb/id.svg";
  mobileImage = "/assets/images/tcb/mobile.svg";
  mobileDescription = "Have your mobile device available to submit required documents and verify your identity.";
  faqUrl = "https://www.texascapitalbank.com/helpful-information/faqs#2254641303-2360509394-3";
}
